import { CheckoutState } from '../../state';
import { areSyncExpressCheckoutEligibleCommonRulesMet } from '../expressCheckout';
import { TLDSupportsGooglePay } from './TLDSupportsGooglePay';

export const areSyncExpressGooglePayEligibleRulesMet = (state: CheckoutState) =>
    areSyncExpressCheckoutEligibleCommonRulesMet(state) &&
    TLDSupportsGooglePay(state);
